import { styled } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';

const BannerWrapper = styled(Box)(({ theme: { spacing, breakpoints } }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  paddingLeft: spacing(2),
  paddingRight: spacing(2),
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '100%',
  [breakpoints.up('sm')]: {
    paddingLeft: 0,
    paddingRight: 0,
    maxWidth: 968,
  },
}));

export default BannerWrapper;
